module.exports = __webpack_public_path__ + "static/media/our-team.e1b4df93.jpg";